import { getProvider } from '@molecule/app-i18n'
import { loadLocaleModule } from '@molecule/app-locales-ide/loader.js'

/** Load the IDE dictionary on entry and before subsequent locale-change notifications. */
export async function setupAppIdeLocales(): Promise<void> {
  const provider = getProvider()
  const load = async (locale: string): Promise<void> => {
    const appLocale = provider.getLocales().find((config) => config.code === locale)
    const [translations, lazyAppTranslations] = await Promise.all([
      loadLocaleModule(locale),
      appLocale?.loader?.(),
    ])
    // The app's dictionaries are flat keys. Use its exact locale, never an
    // exists() lookup that could mistake an English fallback for an override.
    // Vite caches the configured app loader's dynamic import on locale changes.
    if (translations)
      provider.addTranslations(locale, {
        ...translations,
        ...lazyAppTranslations,
        ...appLocale?.translations,
      })
  }
  provider.registerContent?.('ide', load)
  await load(provider.getLocale())
}
